import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import HeroSection from "./components/HeroSection";
import FeaturedProducts from "./components/FeaturedProducts";
import CalendarSection from "./components/CalendarSection";
import Footer from "./components/Footer";
import HeaderCartIcon from "./components/HeaderCartIcon";
import CartDrawer from "./components/CartDrawer";
import ThankYou from "./components/ThankYou";
import "./shared.css";

function HomePageLayout() {
  return (
    <>
      {import.meta.env.DEV && <div className="layout-grid" />}
      <main className="site-wrapper bg-neutral-900 text-white min-h-screen">
        {/* Header with Cart Icon */}
        <header
          className="site-header flex justify-end p-4"
          role="banner"
          aria-label="Site header with shopping cart"
        >
          <HeaderCartIcon />
        </header>

        {/* Hero Section */}
        <HeroSection />

        {/* Featured Products Section */}
        <FeaturedProducts />

        {/* Calendar Section with Error Boundary */}
        <ErrorBoundary>
          <CalendarSection />
        </ErrorBoundary>

        {/* Footer */}
        <Footer />

        {/* Cart Drawer */}
        <CartDrawer />
      </main>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePageLayout />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
